function VerticalCentre({ children }: React.PropsWithChildren) {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    >
      {children}
    </div>
  );
}

export default VerticalCentre;
